import { render } from "./PurchaseManufacturerInfo.vue?vue&type=template&id=51a3d072"
import script from "./PurchaseManufacturerInfo.vue?vue&type=script&lang=js"
export * from "./PurchaseManufacturerInfo.vue?vue&type=script&lang=js"

import "./PurchaseManufacturerInfo.vue?vue&type=style&index=0&id=51a3d072&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__